import { compareDatesWithSequenceIds, SITUATIONAL_DRIVING_CLEAR } from "hos-tools";
import DutyStatusLog, { ALL_HOS_STATUSES, HOS_STANDARD_STATUSES } from "../model/DutyStatusLog";

export const getKnownDeviceId = (id: string | null): string | null => id && id !== "NoDeviceId" ? id : null;

export const getLogKnownDeviceId = (log: DutyStatusLog): string | null => log.device && log.device.id ? getKnownDeviceId(log.device.id) : null;

export const removeHiddenRequestedAdds = (sortedLogs: DutyStatusLog[]) => {
    sortedLogs.sort((a, b) => compareDatesWithSequenceIds(a, b));
    const filteredLogs: DutyStatusLog[] = [];
    let currentExemptionLog: DutyStatusLog | null = null;
    let currentRangeRequestedAdds: DutyStatusLog[] = [];

    const isValidRequestedAdd = (log: DutyStatusLog, rangeStartLog: DutyStatusLog) => {
        return log.requestedAdd && HOS_STANDARD_STATUSES.indexOf(log.status) > -1 && getLogKnownDeviceId(log) === getLogKnownDeviceId(rangeStartLog);
    };
    const isEditableExemptionLog = (log: DutyStatusLog) => log.status === "PC" || log.status === "YM";

    for (const log of sortedLogs) {
        if (isEditableExemptionLog(log)) {
            if (!currentExemptionLog) {
                filteredLogs.push(log);
                currentExemptionLog = log;
                continue;
            }

            // Support for multiple of the same exemption log in one range
            if (log.status === currentExemptionLog.status && getLogKnownDeviceId(log) === getLogKnownDeviceId(currentExemptionLog)) {
                filteredLogs.push(log);
                continue;
            }
        }

        if (currentExemptionLog) {
            if (isValidRequestedAdd(log, currentExemptionLog)) {
                currentRangeRequestedAdds.push(log);
                continue;
            }

            const isSituationalDrivingClear = log.status === SITUATIONAL_DRIVING_CLEAR;
            if (isSituationalDrivingClear || ALL_HOS_STATUSES.indexOf(log.status) > -1) {
                if (!currentExemptionLog.requestedEdit?.isRequestedRemoval && !(isSituationalDrivingClear && log.requestedEdit)) {
                    // PC/YM is not in a valid edit state, do not hide the requested adds
                    filteredLogs.push(...currentRangeRequestedAdds);
                }
                currentRangeRequestedAdds = [];
                currentExemptionLog = isEditableExemptionLog(log) ? log : null;
            }
        }
        filteredLogs.push(log);
    }
    if (currentRangeRequestedAdds.length) {
        filteredLogs.push(...currentRangeRequestedAdds);
    }

    return filteredLogs;
};